'use strict';

var UserProfileDirective = function UserProfileDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/user-profile-panel.html'),
    controller: 'UserProfilePanelController',
    scope: {
      user: '='
    }
  };
};
UserProfileDirective.$inject = [];
module.exports = UserProfileDirective;